import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from './login.service';
import { UsuarioLoginEntity, UsuarioRespuestaEntity } from './usuario_login_entity';
import { HandleError } from "../../components/common/utils/handleError.component";
import { SessionStorageService, SessionStorage } from "ngx-webstorage";
import { ClienteLogin } from "./cliente_login";
import { UsuarioRegistroEntity } from "../register/entities/usuario_registro_entity";
import { verificarUsuarioComponent } from "./verificar-usuario.component";
import { OnChanges } from '@angular/core/src/metadata/lifecycle_hooks';

declare var jQuery: any;
const swal = require("sweetalert2");

@Component({
    selector: 'verificarPregunta',
    templateUrl: 'verificar-pregunta.template.html'
})
export class verificarPreguntaComponent implements OnChanges {
    usuarioRegistro: UsuarioRegistroEntity;
    usuarioLogin: UsuarioLoginEntity;
    errorMessage: string;
    showLoader: string;
    banderaBrowser: number;
    banderaIE: boolean;
    private sub: any;
    @SessionStorage("usuario")
    user: any;
    @SessionStorage("usuarioLogin")
    userLogin: any;
    @SessionStorage("Token")
    Token: any;
    esCliente: boolean;
    @Input() usuarioRespuesta: UsuarioRespuestaEntity;
    showUsuario: boolean;
    showPregunta: boolean;
    respuesta: boolean;

    //nuevo
    @Output() contrasena = new EventEmitter();

    constructor(
        private sessionStorageService: SessionStorageService,
        private loginService: LoginService,
        private route: ActivatedRoute,
        private router: Router,
        private handleError: HandleError,
    ) {
        this.showUsuario = false;
        this.showPregunta = true;
        this.respuesta = false;
    }

    checkBrowser() {
        /**
         * detect IE
         * returns version of IE or false, if browser is not Internet Explorer
         */
        var ua = window.navigator.userAgent;

        // Test values; Uncomment to check result …

        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

        // Edge 12 (Spartan)
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

        // Edge 13
        // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

        var msie = ua.indexOf('MSIE ');
        //console.log(ua);
        if (msie > 0) {
            // IE 10 or older => return version number
            //return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
            this.banderaIE = true;
        } else {

            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                // IE 11 => return version number
                var rv = ua.indexOf('rv:');
                //return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
                this.banderaIE = true;
            } else {
                var edge = ua.indexOf('Edge/');
                if (edge > 0) {
                    // Edge (IE 12+) => return version number
                    //return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
                    this.banderaIE = false;
                } else {
                    // other browser
                    //return false;
                    this.banderaIE = false;
                }
            }
        }
    }

    ngOnChanges(): void {

        this.checkBrowser();
        this.banderaBrowser = 0;
        this.usuarioLogin = new UsuarioLoginEntity();

        this.loginService.traerPreguntaSecreta(this.usuarioRespuesta.Usuario).subscribe(pregunta =>
            this.usuarioRespuesta.Pregunta = pregunta,
            error =>
                this.handleError.redirectUrl(error));


        this.sub = this.route.params.subscribe(params => {
            this.usuarioLogin.Tipo = +params['bandera'];
            if (this.usuarioLogin.Tipo != 1 && this.usuarioLogin.Tipo != 2) {
                this.router.navigate(["/error404"]);
            }
            this.banderaBrowser = this.usuarioLogin.Tipo;
        });

    }

    irInicio() {
        this.router.navigate(['/login', this.banderaBrowser]);
    }

    verificarRespuesta() {

        this.loginService.verificarRespuestaSecreta(this.usuarioRespuesta).subscribe(
            result => {
                if (result) {
                    this.contrasena.emit(this.usuarioRespuesta);
                }
            },
            error => {
                if (error.status == "304") {
                    swal({
                        title: 'Verificación respuesta secreta',
                        text: "Su respuesta no coincide con la que registró en nuestro sistema, por favor vuelva a intentarlo.",
                        type: 'error'
                    });
                } else {
                    this.handleError.redirectUrl(error);
                }
            }
        );
    }

}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/login/verificar-pregunta.component.ts